<template>
  <div class="donutGraph">
    <svg class="p-top-progGraph" viewBox="0 0 168 168">
      <defs>
        <linearGradient :id="'graphGradation_'+graphId" x1="168" y1="84" x2="0" y2="84"
                        gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#5b76f9"/>
          <stop offset="1" stop-color="#24ade4"/>
        </linearGradient>
      </defs>
      <circle class="cls-1" cx="84" cy="84" r="79"/>
      <circle class="cls-2" cx="84" cy="84" r="79" ref="barRef" :style="donutGraph"/>
    </svg>
    <div class="donutGraph__data">
      <div class="textRest">残り</div>
      <div class="textProgress"><span class="achievement">{{ leftMission }}</span>/<span
          class="mission">{{ totalMission }}</span></div>
      <div class="textUnit">問</div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onUnmounted, computed} from "vue";

  const radius = ref(79) // 半径
  const diameter = ref(radius.value * 2) // 直径
  const perimeter = ref(Math.PI * diameter.value) // 円周長
  const leftMission = ref(0)
  const totalMission = ref(0)
  const refresh_timer1 = ref(null)
  const refresh_timer2 = ref(null)
  const barRef = ref(null)

  const props = withDefaults(
    defineProps<{
      clearMissionNum?: number;
      totalMissionNum?: number;
      graphId: string;
    }>(),
    {
      clearMissionNum: 0,
      totalMissionNum: 0,
    }
  );

  const donutGraph = computed(() => {
    return setDonutGraph(false)
  })

  function setDonutGraph(fromAnimate) {
    leftMission.value = props.totalMissionNum - props.clearMissionNum
    totalMission.value = props.totalMissionNum
    let percentage = props.clearMissionNum / props.totalMissionNum; // 割合
    let perimeter_per = perimeter.value * percentage; // 進捗率
    if (fromAnimate) {
      let bar: any = barRef.value
      props.clearMissionNum > 0 ? bar.style.opacity = 1 : bar.style.opacity = 0
      bar.style.strokeDasharray = perimeter_per + " " + perimeter.value;
      bar.style.stroke = 'url("#graphGradation_' + props.graphId + '")';
      bar.style.transition = 'unset'
    } else {
      if (props.clearMissionNum > 0) {
        return {
          'opacity': 1, 'strokeDasharray': perimeter_per + " " + perimeter.value,
          'stroke': 'url("#graphGradation_' + props.graphId + '")', 'transition': 'unset'
        }
      }
    }
  }

  function animate(id) {
    return new Promise((resolve, reject) => {
      leftMission.value = 0
      totalMission.value = props.totalMissionNum
      let bar: any = barRef.value
      let percentage = 1; // 割合
      let perimeter_per = perimeter.value * percentage; // 進捗率
      bar.style.strokeDasharray = 0 + " " + perimeter.value
      refresh_timer1.value = setTimeout(function () {
        bar.style.opacity = 1;
        bar.style.strokeDasharray = perimeter_per + " " + perimeter.value;
        bar.style.stroke = 'url("#graphGradation_' + id + '")';
        bar.style.transition = 'stroke-dasharray 1s'
        resolve(true)
      }, 100);
      refresh_timer2.value = setTimeout(function (){
        setDonutGraph(true)
      },6000);
    })
  }
  onUnmounted(() => {
    clearTimeout(refresh_timer1.value)
    clearTimeout(refresh_timer2.value)
  })
  defineExpose({animate})
</script>
